import React from 'react'
import {useEffect, useState} from 'react'
import Modal from 'react-modal'
import StateStorage from '../../utils/StateStorage'
import {ButtonHeader} from '../Button/ButtonHeader'
import {SIDEBAR_COLLAPSE_STORAGE} from '../Sidebar/MySidebar'

Modal.setAppElement('#root')

export const ModalMessage = ({
  title,
  showModal,
  handleShowModal,
  successButtonAction,
  errorButtonAction
}) => {
  const [modalStyle, setModalStyle] = useState()

  const closeModal = () => handleShowModal(false)

  useEffect(() => {
    setModalStyle({
      content: {
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: !StateStorage.get(SIDEBAR_COLLAPSE_STORAGE) ? '(-230px - 100%)' : '100%',
        height: "100vh",
        padding: 0,
        marginLeft: !StateStorage.get(SIDEBAR_COLLAPSE_STORAGE) ? '230px' : '0',
        justifySelf: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.329)'
      }
    })
  }, [window.localStorage.getItem(SIDEBAR_COLLAPSE_STORAGE)])

  return (
    (!showModal || !modalStyle) ? null :
      <Modal
        onRequestClose={closeModal}
        isOpen={showModal}
        style={modalStyle}>
        <div style={styles.backgroundContainer} onClick={closeModal}>
          <div style={styles.modalContainer}>
            <h1 style={styles.modalTitle}>{title}</h1>
            <div style={styles.buttonsContainer}>
              <ButtonHeader text="Continuar" style={styles.buttonSuccess}
                            onClick={() => {
                              successButtonAction && successButtonAction()
                              handleShowModal(false)
                            }}/>
              <ButtonHeader text="Cancelar" style={styles.buttonError}
                            onClick={() => {
                              errorButtonAction && errorButtonAction()
                              handleShowModal(false)
                            }}/>
            </div>
          </div>
        </div>
      </Modal>
  )
}

const styles = {
  backgroundContainer: {
    width: "100%",
    height: "100%",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: "80%",
    height: "fit-content",
    backgroundColor: 'white',
    borderRadius: 16,
    padding: '3%'
  },
  modalTitle: {
    textAlign: 'center',
    width: '100%',
    paddingTop: '2%',
    padding: '2%',
    fontSize: '2.3rem'
  },
  content: {
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: "80%",
      height: "100%",
      marginLeft: '15%',
      justifySelf: 'center',
      backgroundColor: 'transparent'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.329)'
    }
  },
  buttonsContainer: {
    display: 'flex',
    marginTop: '5%',
    width: '100%',
    paddingBottom: '2%',
    height: '40%',
    justifyContent: 'space-around'
  },
  buttonSuccess: {
    backgroundColor: '#00af91',
    height: '45px',
    width: '30%',
    borderRadius: '4px',
    border: 'none',
    outline: 'none',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '19px',
    color: 'white',
    textAlign: 'center',
    letterSpacing: '0.01em',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)'
  },
  buttonError: {
    backgroundColor: '#ec4646',
    height: '45px',
    width: '30%',
    borderRadius: '4px',
    border: 'none',
    outline: 'none',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '19px',
    color: 'white',
    textAlign: 'center',
    letterSpacing: '0.01em',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)'
  }
};



// WEBPACK FOOTER //
// ./src/component/Modal/ModalMessage.js